import { render } from "./tagWidget.vue?vue&type=template&id=6a6dffdc"
import script from "./tagWidget.vue?vue&type=script&lang=js"
export * from "./tagWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__